import { useQuery } from '@tanstack/react-query'
import { useEffect, useState } from 'react'
import { EnumAccessLevel } from '../../../@types'
import services from '../../../services'

export function useData() {
  const ROLES: Array<EnumAccessLevel> = [
    'ADMIN',
    'FINANCE',
    'STUDENT',
    'TEACHER',
  ]

  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['/users?type=USER'],
    queryFn: () => services.user.getByType('USER'),
  })

  const [users, setUsers] = useState(data ?? [])

  useEffect(() => {
    if (data) setUsers(data)
  }, [data])

  return {
    isLoading,
    error,
    users,
    ROLES,
    refetch,
  }
}
